"use client";

import React, { useState } from "react";

// Email subscription section – matches the provided design exactly
export default function Email() {
  const [email, setEmail] = useState("");

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // TODO: hook up submit action
  };

  return (
    <section className="w-full bg-F8F8F8 py-12 px-4 border-[0.1px] border-E8E8E8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 ">
        {/* Heading */}
        <h2 className="text-center font-tamil text-20-tamil-700 text-test-primary">
          எங்கள் செய்திகளுக்கு குழுசேரவும்
        </h2>

        {/* Subheading */}
        <p className="mt-3 text-center font-tamil text-14-tamil-400 text-4D4D4D">
          நாளை நீங்கள் பேசப்போகும் கதைகள் - இன்று உங்கள் இன்பாக்ஸில் நேரடியாக வழங்கப்படும்
        </p>

        {/* Form */}
        <form
          onSubmit={onSubmit}
          className="mt-8 flex w-full items-stretch justify-center"
          aria-label="Email subscription form"
        >
          <div className="flex w-full sm:w-auto sm:max-w-3xl mx-auto h-[44px] sm:h-[48px] overflow-hidden border-[2px] border-215EF9">
            {/* Icon cell */}
            <div className="flex items-center justify-center px-3 sm:px-4 text-215EF9  h-full">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-215EF9 sm:w-[22px] sm:h-[22px]"
              >
                <path
                  d="M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 7l8 6 8-6"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {/* Input */}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="உங்கள் மின்னஞ்சல் முகவரி"
              className="flex-1 sm:w-[280px] md:w-[330px] h-full placeholder:text-808080-500 text-020202 px-2 sm:px-4 py-0 text-[14px] sm:text-[15px] outline-none focus:outline-none"
              aria-label="Email address"
            />

            {/* Submit */}
            <button
              type="submit"
              className="group inline-flex items-center justify-center bg-[#215EF9] text-FFFFFF px-2 sm:px-5 md:px-6 whitespace-nowrap text-14-tamil-400 hover:opacity-90 transition-opacity h-full sm:gap-2"
            >
              <span className="hidden sm:inline">அனுப்பு</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="h-4 w-4 text-FFFFFF"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
